import { NgModule } from '@angular/core';

import { MediationComponent, MediationService } from './';
import { SharedModule } from "../shared/shared.module";
import { CommonModule } from "@angular/common";


@NgModule({
    imports: [CommonModule, SharedModule],
    exports: [],
    declarations: [MediationComponent],
    providers: [MediationService],
})
export class MediationModule { }


// WEBPACK FOOTER //
// ./src/app/mediation/mediation.module.ts